export enum Statuses {
  ACTIVE = 'Active',
  INACTIVE = 'Inactive'
}
